const normalizeRole = (role: any) =>
  (role?.name ?? role ?? "")
    .toString()
    .toLowerCase()
    .replace(/^role_?/, "") // remove typical ROLE_ prefix
    .replace(/[\s\-_]/g, "");

export const hasRole = (userRoles: any, rolesToCheck: string[]) => {
  const normalizedTargets = rolesToCheck.map(normalizeRole);
  return userRoles?.some((role: any) =>
    normalizedTargets.includes(normalizeRole(role))
  );
};

export const isAdmin = (roles: any) =>
  hasRole(roles, ["ROLE_ADMIN", "admin", "ROLE_SUPERADMIN", "superadmin"]);

export const isModerator = (roles: any) =>
  hasRole(roles, [
    "ROLE_MODERATOR",
    "moderator",
    "ROLE_SUPERADMIN",
    "superadmin",
  ]);

export const isSuperAdmin = (roles: any) =>
  hasRole(roles, ["ROLE_SUPERADMIN", "superadmin"]);

export const hasPermissionKey = (
  effectivePermissions: string[] | undefined,
  permissionKey?: string
) => {
  if (!permissionKey) return true;
  if (!effectivePermissions) return true; // dok se ne učita sa servera
  return effectivePermissions.includes(permissionKey);
};

export const hasAnyPermissionKey = (
  effectivePermissions: string[] | undefined,
  keys: string[] = []
) => keys.some((key) => hasPermissionKey(effectivePermissions, key));
